import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

interface BackButtonProps {
  showButton?: boolean;
}

const BackButton: React.FC<BackButtonProps> = ({ showButton = true }) => {
  const navigate = useNavigate();

  if (!showButton) return null;

  return (
    <button
      onClick={() => navigate(-1)}
      className="flex items-center gap-2 bg-amber-100 text-amber-800 hover:bg-amber-200 transition-colors px-4 py-2 rounded-full text-sm font-medium shadow-sm"
    >
      <FontAwesomeIcon icon={faArrowLeft} className="h-4 w-4" />
      <span>Back</span>
    </button>
  );
};

export default BackButton;
